import { Divider, Grid } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { ReportHeader } from "./subComponents/reportHeader";

import PendingChequeReport from "./Cheque/PendingCheque";
import ClearedChequeReport from "./Cheque/ClearedCheque";
import BouncedChequeReport from "./Cheque/BouncedCheque";
import MonthlyChequeReport from "./Cheque/MonthlyCheque";
import StockMovementReport from "./Inventory/StockMovement";
import LowStockReport from "./Inventory/LowStock";
// import CurrentStockReport from "./Inventory/CurrentStock";
import ItemWiseReport from "./Inventory/ItemWise";
import ValuationReport from "./Inventory/Valuation";

export const InventoryReports: React.FC<any> = React.memo(
    () => {
        const { control } = useForm();
        const tabsData: any[] = [
            // { label: "Current Stock", content: <CurrentStockReport /> },
            { label: "Item Wise", content: <ItemWiseReport /> },
            { label: "Low Stock", content: <LowStockReport /> },
            { label: "Stock Movement", content: <StockMovementReport /> },
            { label: "Valuation", content: <ValuationReport /> },
        ];

        return (
            <>
                {" "}
                <Grid item container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
                <ReportHeader
                    title="Inventory Report"
                    type="light"
                    color="primary"
                    isBackButton={true}
                    url="/"
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} >
                        <WSTabs
                            id="adasd"
                            control={control}
                            name="tabs"
                            tabs={tabsData}
                            justifyTabs="flex-start"
                        />
                    </Grid>
                </Grid>
            </>
        );
    }
);

export const ChequeReports: React.FC<any> = React.memo(
    () => {
        const { control } = useForm();
        const tabsData: any[] = [
            { label: "Pending Cheque", content: <PendingChequeReport /> },
            { label: "Cleared Cheque", content: <ClearedChequeReport /> },
            { label: "Bounced Cheque", content: <BouncedChequeReport /> },
            { label: "Monthly Cheque", content: <MonthlyChequeReport /> },
        ];

        return (
            <>
                {" "}
                <Grid item container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
                <ReportHeader
                    title="Cheque Report"
                    type="light"
                    color="primary"
                    isBackButton={true}
                    url="/"
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} >
                        <WSTabs
                            id="adasd"
                            control={control}
                            name="tabs"
                            tabs={tabsData}
                            justifyTabs="flex-start"
                        />
                    </Grid>
                </Grid>
            </>
        );
    }
);
